export default {
    setShowRightSideBarFalse(context) {
        context.commit('setShowRightSideBarFalse')
    },
    setShowRightSideBarTrue(context) {
        // console.log('set show right side bar true')
        context.commit('setShowRightSideBarTrue')
    },
}